export const SIGNATURE_UPLOAD_ACCEPT = ".jpg,.jpeg,.png";
export const SIGNATURE_UPLOAD_MIME_TYPES = ["image/jpeg", "image/png"];
export const SIGNATURE_UPLOAD_ERROR =
  "Only .jpg, .jpeg and .png files are allowed.";
export const SIGNATURE_UPLOAD_LABEL = "Upload Signature";
